import Vue from 'vue';
import apiClient from '@/apiClient';
// import { rejects } from 'assert';

const state = {
  logoUrl: '',
  backgroundUrl: '',
  videoUrl: '',
  userInstruction: '',
  tagline: '',
  showCalculation: false
};

const getters = {
  branding: state => ({
    logoUrl: state.logoUrl,
    backgroundUrl: state.backgroundUrl,
    tagline: state.tagline,
    userInstruction: state.userInstruction,
    videoUrl: state.videoUrl
  }),
  logoUrl: state => state.logoUrl,
  backgroundUrl: state => state.backgroundUrl,
  tagline: state => state.tagline,
  userInstruction: state => state.userInstruction,
  videoUrl: state => state.videoUrl,
  showCalculation: state => state.showCalculation
};

const actions = {
  loadBranding: ({ commit }, { firmId, constructorId }) =>
    new Promise((resolve, reject) => {
      apiClient
        .get(`/firms/${firmId}/constructors/${constructorId}/branding`)
        .then(resp => {
          commit('brandingData', resp.data);
          resolve(resp);
        })
        .catch(error => {
          // bad news. Return error. Do not commit data to store
          reject(error);
        });
    }),

  updateBranding: ({ commit }, { firmId, constructorId, data }) =>
    new Promise((resolve, reject) => {
      apiClient
        .put(`/firms/${firmId}/constructors/${constructorId}/branding`, data)
        .then(response => {
          // all good. Commit updated data to store
          commit('brandingData', response.data);
          resolve(response);
        })
        .catch(error => {
          // bad news. Return error. Do not commit data to store
          reject(error);
        });
    })
};

const mutations = {
  brandingData: (state, brandingData) => {
    state.logoUrl = brandingData.logoUrl;
    state.backgroundUrl = brandingData.backgroundUrl;
    state.videoUrl = brandingData.videoUrl;
    state.userInstruction = brandingData.userInstruction;
    state.tagline = brandingData.tagline;
    state.showCalculation = brandingData.showCalculation;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};
